var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-small back-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v("Volver atrás")])])}
var staticRenderFns = []

export { render, staticRenderFns }